export const billCategories = [
  "Rent",
  "Subscription",
  "Penalty",
  "Deposit",
  "Fine",
  "Point",
  "GiftRent",
  "GiftPenalty",
  "MEMBERSHIP",
  "TAXI",
  "TAXI_CALL_FEE",
  "TIMEPASS",
  "DAILYPASS",
  "TRANSIT_CARD",
  "TRANSIT_CARD_ISSUE",
  "TRANSIT_CARD_REISSUE",
  "TRANSIT_CARD_CANCEL",
  "RENTAL_CAR",
  "DEER_UNPAID",
  "DEER_RENT",
  "DEER_PENALTY",
  "SWAP",
  "Other",
] as const;
export type BillCategoryType = (typeof billCategories)[number];

export const BillCategoryTranslate: Record<BillCategoryType, string> = {
  Rent: "대여",
  Subscription: "구독",
  Penalty: "패널티",
  Deposit: "보증금",
  Fine: "견인/과태료",
  Point: "포인트",
  GiftRent: "선물대여",
  GiftPenalty: "선물패널티",
  MEMBERSHIP: "멤버십",
  TAXI: "택시",
  TAXI_CALL_FEE: "택시 호출료",
  TIMEPASS: "타임패스/디어상점",
  DAILYPASS: "매일매일 이용권",
  TRANSIT_CARD: "교통카드 충전",
  TRANSIT_CARD_ISSUE: "교통카드 발급",
  TRANSIT_CARD_REISSUE: "교통카드 재발급",
  TRANSIT_CARD_CANCEL: "서울패스 취소 수수료",
  RENTAL_CAR: "렌터카",
  DEER_UNPAID: "디어 미납 해소",
  DEER_RENT: "디어 이용요금",
  DEER_PENALTY: "디어 주차페널티",
  SWAP: "스왑",
  Other: "외 기타",
};
